import { Spin } from 'antd';
import { isEmpty } from 'lodash';
import { useMemo, useState } from 'react';
import IndeterminateCheckbox from 'components/@extended/IndeterminateCheckbox';
import ComptrollerDataTable from 'pages/comptroller/comptroller-table/ComptrollerDataTable';

const ListViewKpiComparative = ({ data, isLoading }) => {
	const [rowSelection, setRowSelection] = useState([]);

	const COLUMNS = useMemo(
		() => [
			// {
			// 	id: 'Selection',
			// 	align: 'center',
			// 	onClicked: true,
			// 	cellAlign: 'center',
			// 	Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
			// 	Header: ({ getToggleAllRowsSelectedProps, index }) => (
			// 		<IndeterminateCheckbox id={index + '1'} sx={{ color: '#858585', padding: '0px' }} {...getToggleAllRowsSelectedProps()} />
			// 	),
			// },
			{
				Header: 'Function ID',
				accessor: 'functionMasterId',
			},
			{
				Header: 'Function Name',
				accessor: 'functionName',
			},
			{
				cellAlign: 'right',
				Header: 'Users Found',
				accessor: 'usersFound',
			},
			// {
			// 	Header: 'Total Raw Score',
			// 	accessor: 'totalRawScore',
			// },
			{
				Header: 'User Evaluated',
				accessor: 'userEvaluated',
			},
			{
				Header: 'Lowest Raw Score',
				accessor: 'lowestRawScore',
			},
			{
				Header: 'Average Raw Score',
				accessor: 'averageRawScore',
			},
			{
				Header: 'Highest Raw Score',
				accessor: 'highestRawScore',
			},
			// {
			// 	Header: 'Total Weighted Score',
			// 	accessor: 'totalWeightedScore',
			// },
			{
				Header: 'Lowest Weighted Score',
				accessor: 'lowestWeightedScore',
			},
			{
				Header: 'Average Weighted Score',
				accessor: 'averageWeightedScore',
			},
			{
				Header: 'Highest Weighted Score',
				accessor: 'highestWeightedScore',
			},
		],
		[]
	);

	return (
		<Spin spinning={isLoading} style={{ maxHeight: '100%' }}>
			<ComptrollerDataTable
				COLUMNS={COLUMNS}
				onClickHandler={() => {}}
				rowSelection={rowSelection}
				DATA={isEmpty(data) ? [] : data}
				setRowSelection={setRowSelection}
				xlsxFileName="kpi-comparative-console"
			/>
		</Spin>
	);
};

export default ListViewKpiComparative;
